

export function getData (usuarios, dataType) {

    let data = [];
    let legenda = [];
    if (dataType === 'IMC') { 
	    data[0] = usuarios.filter(u => u.IMC < 18.5).length
	    legenda[0] = 'Abaixo'
	    data[1] = usuarios.filter(u => u.IMC >= 18.5 && u.IMC < 24.9).length
	    legenda[1] = 'Normalidade'
	    data[2] = usuarios.filter(u => u.IMC >= 25 && u.IMC < 30).length
	    legenda[2] = 'Sobrepeso'
	    data[3] = usuarios.filter(u => u.IMC >= 30).length
		legenda[3] = 'Obesidade'
	}else if (dataType === 'Peso') {
		data[0] = usuarios.filter(u => u.peso < 40).length
	    legenda[0] = 'S.Leve'
	    data[1] = usuarios.filter(u => u.peso >= 40 && u.peso < 50).length
	    legenda[1] = 'Leve'
	    data[2] = usuarios.filter(u => u.peso >= 50 && u.peso < 60).length
	    legenda[2] = 'L.Medio'
	    data[3] = usuarios.filter(u => u.peso >= 60 && u.peso < 70).length
		legenda[3] = 'Medio'
		data[4] = usuarios.filter(u => u.peso >= 70 && u.peso < 80).length
		legenda[4] = 'P.Medio'
		data[5] = usuarios.filter(u => u.peso >= 80 && u.peso < 90).length
		legenda[5] = 'Pesado'
		data[6] = usuarios.filter(u => u.peso >= 90 ).length
		legenda[6] = 'S.Pesado'
	}else if (dataType === 'Idade') {
		data[0] = usuarios.filter(u => u.idade >= 2 && u.idade <= 10).length
	    legenda[0] = 'Criança'
	    data[1] = usuarios.filter(u => u.idade >= 11 && u.idade <= 17).length
	    legenda[1] = 'Adolescente'
	    data[2] = usuarios.filter(u => u.idade >= 18 && u.idade <= 40).length
	    legenda[2] = 'Jovem'
	    data[3] = usuarios.filter(u => u.idade >= 41 && u.idade <= 65).length
		legenda[3] = 'Adulto'
		data[4] = usuarios.filter(u => u.idade > 65).length
		legenda[4] = 'Idoso'
	}else if (dataType === 'Altura') {
		data[0] = usuarios.filter(u => u.altura < 150).length
	    legenda[0] = 'baixa'
	    data[1] = usuarios.filter(u => u.altura >= 150 && u.altura < 160).length
	    legenda[1] = 'Media/Baixa'
	    data[2] = usuarios.filter(u => u.altura >= 160 && u.altura < 170).length
	    legenda[2] = 'Media'
	    data[3] = usuarios.filter(u => u.altura >= 170 && u.altura < 180).length
		legenda[3] = 'Media/Alta'
		data[4] = usuarios.filter(u => u.altura >= 180).length
		legenda[4] = 'Alta'
	}


    return [data, legenda];
}

export function reArrangeData (usuarios, nivel, tipo){
	var users = [];
	if(tipo === 'IMC'){
		if(nivel === 'Obesidade'){
			users = usuarios.filter(u => u.IMC >= 30).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.IMC >= 30)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if(nivel === 'Sobrepeso'){
			users = usuarios.filter(u => u.IMC >= 25 && u.IMC < 30).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.IMC >= 25 && u.IMC < 30)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if(nivel === 'Normalidade'){
			users = usuarios.filter(u => u.IMC >= 18.5 && u.IMC < 24.9).sort((a, b) => {return b.IMC - a.IMC}).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.IMC >= 18.5 && u.IMC < 24.9)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if (nivel === 'Abaixo') {
			users = usuarios.filter(u => u.IMC < 18.5).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.IMC < 18.5)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else {
			users.push(usuarios)
		}
	}else if(tipo === 'Peso'){
		if(nivel === 'S.Leve'){
			users = usuarios.filter(u => u.peso < 40).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso < 40)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}else if(nivel === 'Leve'){
			users = usuarios.filter(u => u.peso >= 40 && u.peso < 50).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso >= 40 && u.peso < 50)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}else if(nivel === 'L.Medio'){
			users = usuarios.filter(u => u.peso >= 50 && u.peso < 60).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso >= 50 && u.peso < 60)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}else if (nivel === 'Medio') {
			users = usuarios.filter(u => u.peso >= 60 && u.peso < 70).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso >= 60 && u.peso < 70)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}else if(nivel === 'P.Medio'){
			users = usuarios.filter(u => u.peso >= 70 && u.peso < 80).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso >= 70 && u.peso < 80)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}else if(nivel === 'Pesado'){
			users = usuarios.filter(u => u.peso >= 80 && u.peso < 90).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso >= 80 && u.peso < 90)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}else if(nivel === 'S.Pesado'){
			users = usuarios.filter(u => u.peso >= 90).sort((a, b) => {return b.peso - a.peso})
			usuarios.filter(u => !(u.peso >= 90)).sort((a, b) => {return b.peso - a.peso}).map((u) => {users.push(u)})
		}
	}else if(tipo === 'Idade'){
		if(nivel === 'Criança'){
			users = usuarios.filter(u => u.idade >= 2 && u.idade <= 10).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.idade >= 2 && u.idade <= 10)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if(nivel === 'Adolescente'){
			users = usuarios.filter(u => u.idade >= 11 && u.idade <= 17).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.idade >= 11 && u.idade <= 17)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if(nivel === 'Jovem'){
			users = usuarios.filter(u => u.idade >= 18 && u.idade <= 40).sort((a, b) => {return b.IMC - a.IMC}).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.idade >= 18 && u.idade <= 40)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if (nivel === 'Adulto') {
			users = usuarios.filter(u => u.idade >= 41 && u.idade <= 65).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.idade >= 41 && u.idade <= 65)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if (nivel === 'Idoso'){
			users.users = usuarios.filter(u => u.idade > 65).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.idade > 65)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}
	}else if(tipo === 'Altura'){
		if(nivel === 'Baixa'){
			users = usuarios.filter(u => u.altura <= 150).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.altura <= 150)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if(nivel === 'Adolescente'){
			users = usuarios.filter(u => u.altura <= 150).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.altura <= 150)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if(nivel === 'Jovem'){
			users = usuarios.filter(u => u.altura <= 150).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.altura <= 150)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if (nivel === 'Adulto') {
			users = usuarios.filter(u => u.altura <= 150).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.altura <= 150)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}else if (nivel === 'Idoso'){
			users = usuarios.filter(u => u.altura <= 150).sort((a, b) => {return b.IMC - a.IMC})
			usuarios.filter(u => !(u.altura <= 150)).sort((a, b) => {return b.IMC - a.IMC}).map((u) => {users.push(u)})
		}
	}
	

	return users
}


// WEBPACK FOOTER //
// ./src/components/Data.js